    <div class="auth-shell auth-shell-register">
      <aside class="auth-aside">
        <div class="auth-brand">
          <img class="auth-logo" src="/rectangular%20logo.PNG" alt="Central Profile" />
          <span class="eyebrow">Account creation</span>
          <h2 class="hero-title">Create one trusted profile for every institution that needs your latest details.</h2>
          <p class="hero-copy">Register once, then manage number changes, address updates, billing profiles, and contact recovery in one secure hub.</p>
        </div>

        <ul class="auth-points">
          <li>Capture national ID or passport details</li>
          <li>Maintain physical and billing addresses</li>
          <li>Prepare OTP preferences and recovery flows</li>
        </ul>
      </aside>

      <section class="auth-panel">
        <div class="auth-card auth-card-register">
          <h2 class="page-title auth-title-reset">Register</h2>

          <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">

            <!-- Personal details -->
            <p class="form-section-label">Personal details</p>
            <div class="field-grid">
              <div class="input-group">
                <label for="fullName">Name and surname</label>
                <input id="fullName" formControlName="fullName" placeholder="Jane Dlamini" />
              </div>
              <div class="input-group">
                <label for="identityNumber">ID or passport number</label>
                <input id="identityNumber" formControlName="identityNumber" placeholder="9901015009087" />
              </div>
              <div class="input-group">
                <label for="phoneNumber">Phone number</label>
                <input id="phoneNumber" formControlName="phoneNumber" placeholder="+27 72 123 4567" />
              </div>
              <div class="input-group">
                <label for="email">Email address</label>
                <input id="email" type="email" formControlName="email" placeholder="jane@example.com" />
              </div>
            </div>

            <!-- Address -->
            <p class="form-section-label form-section-label-spaced">Address</p>
            <div class="form-stack form-stack-tight">
              <div class="input-group">
                <label for="addressLine1">Address line 1</label>
                <input id="addressLine1" formControlName="addressLine1" placeholder="14 Long Street" />
              </div>
              <div class="input-group">
                <label for="addressLine2">Address line 2 (optional)</label>
                <input id="addressLine2" formControlName="addressLine2" placeholder="Unit 5" />
              </div>
              <div class="field-grid">
                <div class="input-group">
                  <label for="suburb">Suburb</label>
                  <input id="suburb" formControlName="suburb" placeholder="Observatory" />
                </div>
                <div class="input-group">
                  <label for="town">Town / City</label>
                  <input id="town" formControlName="town" placeholder="Cape Town" />
                </div>
                <div class="input-group">
                  <label for="province">Province</label>
                  <input id="province" formControlName="province" placeholder="Western Cape" />
                </div>
                <div class="input-group">
                  <label for="postalCode">Postal code</label>
                  <input id="postalCode" formControlName="postalCode" placeholder="7925" />
                </div>
              </div>
            </div>

            <!-- Password -->
            <p class="form-section-label form-section-label-spaced">Set password</p>
            <div class="field-grid">
              <div class="input-group">
                <label for="password">New password</label>
                <input id="password" type="password" formControlName="password" />
              </div>
              <div class="input-group">
                <label for="confirmPassword">Confirm password</label>
                <input id="confirmPassword" type="password" formControlName="confirmPassword" />
              </div>
            </div>

            <div class="btn-row">
              <button class="btn btn-primary" type="submit">Create account</button>
              <a class="btn btn-secondary" routerLink="/login">Return to login</a>
            </div>
          </form>
        </div>
      </section>
    </div>
